module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reservationComp && _vm.isActiveComp == true && !_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "small-h2 text-center",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" Booking ID: "), _c('strong', [_vm._v(_vm._s(_vm.reservationComp.BookingNumber) + " ")])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "5px"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "hidden-lg hidden-md"
  }, [_c('button', {
    staticClass: "hidden-md hidden-lg btn btn-block btn-lg btn-info btn-title",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#summary"
    },
    on: {
      "click": function($event) {
        _vm.switchCollapse()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa fa-navicon"
  }), _vm._v("   " + _vm._s(_vm.summaryComp))]), _vm._v(" "), _c('div', {
    staticClass: " hidden-md hidden-lg collapse",
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px",
      "margin-right": "0px",
      "padding-right": "0px"
    },
    attrs: {
      "id": "summary",
      "aria-expanded": "true"
    }
  }, [_c('div', {
    staticClass: "reservationSummary"
  }, [_vm._l((_vm.reservationComp.AvailablePetDtos), function(petCard) {
    return _c('div', [_c('div', [_c('PetSelectCard', {
      key: petCard.PetId,
      attrs: {
        "showDetails": true,
        "petId": petCard.PetId
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-desc"
  }, [_c('h5', [_vm._v("Total Days: " + _vm._s(_vm.reservationComp.TotalDays))]), _vm._v(" "), _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.reservationComp.ServicePriceSummaryDtos), function(service) {
    return _c('h5', [_vm._v(_vm._s(service.Description))])
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-success"
  }, [_vm._v("Total Price: " + _vm._s(_vm.reservationComp.TotalPrice) + " " + _vm._s(_vm.currencyComp))])], 2)], 2)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7 remove-margins"
  }, [(_vm.reservationComp.SitterStatus) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: _vm.reservationComp.StatusClass,
    attrs: {
      "role": "alert"
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.reservationComp.SitterStatus))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "media-left"
  }, [_c('img', {
    staticClass: "media-object img-responsive img-circle",
    attrs: {
      "src": _vm.reservationComp.CustomerProfilePic,
      "alt": "",
      "height": "25",
      "width": "25"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-left head-title"
  }, [_c('h4', {
    staticClass: "media-heading ",
    staticStyle: {
      "display": "inline-block",
      "padding-bottom": "0px",
      "margin-bottom": "0px"
    }
  }, [_vm._v(" " + _vm._s(_vm.reservationComp.CustomerName))])]), _vm._v(" "), (_vm.signalReadyComp) ? _c('Chat', {
    attrs: {
      "isSitterAccepted": _vm.reservationComp.IsSitterAccepted,
      "transactionId": _vm.reservationIdComp
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.rejectedComp) ? _c('div', {
    staticClass: "buttons"
  }, [(_vm.notStartedComp) ? _c('div', {
    staticClass: "buttons-started"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "disabled": _vm.reservationComp.IsSitterAccepted == true
    },
    on: {
      "click": function($event) {
        _vm.acceptReservation()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v("\n                " + _vm._s(_vm.acceptedButton))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block  btn-warning",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "hover",
      "data-placement": "top"
    },
    on: {
      "click": function($event) {
        _vm.rejectRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v("\n                Reject Request")]), _vm._v(" "), _c('br')]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.rejectedComp) ? _c('div', [(!_vm.reservationComp.IsSitterRemoved) ? _c('button', {
    staticClass: "btn btn-warning btn-block",
    staticStyle: {
      "margin-bottom": "5px"
    },
    on: {
      "click": function($event) {
        _vm.removeDashboard()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _vm._v("\n            Remove from Bookings")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-block btn-lg",
    on: {
      "click": function($event) {
        _vm.goMySitterReservations()
      }
    }
  }, [_vm._v("View all Bookings")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs hidden-sm col-md-4 pull-right reservationSummary"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(" Summary ")]), _vm._v(" "), _vm._l((_vm.reservationComp.AvailablePetDtos), function(petCard) {
    return _c('div', {
      key: petCard.PetId
    }, [_c('div', [_c('PetSelectCard', {
      attrs: {
        "showDetails": true,
        "petId": petCard.PetId
      }
    })], 1)])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', [_vm._v("Total Days: " + _vm._s(_vm.reservationComp.TotalDays))]), _vm._v(" "), _c('h5', [_vm._v("Dates: " + _vm._s(_vm.startDateComp) + " - " + _vm._s(_vm.endDateComp))]), _vm._v(" "), _vm._l((_vm.reservationComp.ServicePriceSummaryDtos), function(service) {
    return _c('h5', [_vm._v(_vm._s(service.Description))])
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-success"
  }, [_vm._v("Total Price: " + _vm._s(_vm.reservationComp.TotalPrice) + " " + _vm._s(_vm.currencyComp))])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isActiveComp == false) ? _c('div', [_c('br'), _vm._v(" "), _c('h1', {
    staticClass: "text-center"
  }, [_vm._v("You need to have an active membership to view this reservation")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Note: Only customers who are members can reach out to you without Premium membership")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-premium",
    on: {
      "click": function($event) {
        _vm.goSubscribe()
      }
    }
  }, [_vm._v("Go Premium "), _c('i', {
    staticClass: "fa fa-paw"
  })]), _vm._v(" "), _c('br')])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "bounce1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce2"
  }), _vm._v(" "), _c('div', {
    staticClass: "bounce3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a48a1086!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sitters/Reservation/ViewSitterReservationComponent.vue
// module id = 649
// module chunks = 2